import { BrowserRouter as Router } from "react-router-dom";
import React from "react";
import LandingPage from "./landingpage";
import Login from "./login";
import Mapshow from "./maproute";
import ProfilePage from "./profile";
import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import ForecastForm from "./ForecastForm";

function App() {
  const token = localStorage.getItem("token");
  const user_role = localStorage.getItem("role"); // Assuming you have a way to get the user role from the token or context
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        {/* <Route path="/home" element={<LandingPage />} /> */}

        {token ? (
          <>
            <Route path="/map" element={<Mapshow />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/home" element={<LandingPage />} />
            <Route path="/forecast" element={<ForecastForm />} />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/" />} />
        )}

        {/* Catch-All Route (404 Page) */}
        <Route path="*" element={<h2>404 - Page Not Found</h2>} />
      </Routes>
    </Router>
  );
}

export default App;
